import { apiSlice } from "./api/apiSlice";

const InvertorySLice = apiSlice.injectEndpoints({
    endpoints:(builder)=>({
        getAllInventory: builder.query({
            query:({ 
                project, 
                unitType, 
                projectBlock, 
                unitNo, 
                status,
                bed,
                location,
                crossArea,
                features,
                plotSize,
                minPrice,
                maxPrice,
                minMarlaPrice,
                maxMarlaPrice,
                areaInFet,
                areaInMarla,
            })=>{
                const params = new URLSearchParams();
                if (project) params.append('project', project);
                if (unitType) params.append('unitType', unitType);
                if (projectBlock) params.append('projectBlock', projectBlock);
                if (unitNo) params.append('unitNo', unitNo);
                if (status) params.append('status', status);
                if (bed) params.append('bed', bed);
                if (location) params.append('location', location);
                if (crossArea) params.append('crossArea', crossArea);
                if (features) params.append('features', features);
                if (plotSize) params.append('plotSize', plotSize);
                if (minPrice) params.append('minPrice', minPrice);
                if (maxPrice) params.append('maxPrice', maxPrice);
                if (minMarlaPrice) params.append('minMarlaPrice', minMarlaPrice);
                if (maxMarlaPrice) params.append('maxMarlaPrice', maxMarlaPrice);
                if (areaInFet) params.append('areaInFet', areaInFet);
                if (areaInMarla) params.append('areaInMarla', areaInMarla);
                
                return { url: `inventory?${params.toString()}` };
            },
            transformResponse:(response,meta,arg)=>response.inventory,
            providesTags:(result,error,id)=>[{type:'Inventory'}]
        }),

        createInventory:builder.mutation({
            query:(inventory)=>({
                url:'inventory/create',
                method: 'POST',
                body:inventory
            }),
            invalidatesTags:['Inventory']
        }),

        deleteInventory:builder.mutation({
            query:(id)=>({
                url:`inventory/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags:['Inventory']
        }),

        getSingleInventory:builder.query({
            query:(id)=>({
                url:`inventory/${id}`,
            }),
            transformResponse:(response,meta,arg)=>response.inventory,
            providesTags:['Inventory']
        }),
        getInventoryByProjectId:builder.query({
            query:({project,block})=>({
                url:`/inventory/getinventoryby/projectid?projectID=${project}&projectBlock=${block}`,
            }),
            transformResponse:(response,meta,arg)=>response.inventory,
            providesTags:['Inventory']
        }),
        updateInventory:builder.mutation({
            query:(id,inventory)=>({
                url:`inventory/${id}`,
                method: 'PUT',
                body:inventory
            }),
            invalidatesTags:['Inventory']
        })

    })
})

export const {useGetAllInventoryQuery,useCreateInventoryMutation,useDeleteInventoryMutation,useGetSingleInventoryQuery,useLazyGetInventoryByProjectIdQuery,useUpdateInventoryMutation} = InvertorySLice;